import { LogLevel } from '@azure/msal-browser';
import { redirect } from 'react-router-dom';

 /**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        clientId: '4e43d5a3-aebb-4355-87e1-4d4ae9ed610b', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/738ca59b-09e4-425a-a1ed-2ec16fc30453', // Replace the placeholder with your tenant info
        //redirectUri: "https://flyermaker.murdochs.com", // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        redirectUri: "https://flyermaker.murdochs.com",
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};


export const loginRequest = {
    scopes: ["openid", "profile"],
    prompt: "consent"
};